import { AppleDevice } from '@era/locations-sdk';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export function selectAppleDeviceId(device: AppleDevice) {
  return device.udid;
}

export const adapter: EntityAdapter<AppleDevice> = createEntityAdapter<AppleDevice>({
  selectId: selectAppleDeviceId,
});

export type AppleDeviceState = EntityState<AppleDevice>;

export const initialState: AppleDeviceState = adapter.getInitialState();
